var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseSidebarLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_748_15124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0199 15.9655C14.1428 15.9655 17.4851 12.6233 17.4851 8.50034C17.4851 4.37743 14.1428 1.03516 10.0199 1.03516C5.89697 1.03516 2.55469 4.37743 2.55469 8.50034C2.55469 12.6233 5.89697 15.9655 10.0199 15.9655Z",
    stroke: "#9B59B6",
    strokeWidth: 0.920842,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5874 10.3564C1.8179 10.3564 1.19531 9.7324 1.19531 8.96435C1.19531 8.1963 1.81935 7.57227 2.5874 7.57227",
    stroke: "#9B59B6",
    strokeWidth: 0.920842,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3076 10.4082C11.3076 11.0497 10.6836 11.569 9.91552 11.569C9.14748 11.569 8.52344 11.0497 8.52344 10.4082",
    stroke: "#9B59B6",
    strokeWidth: 0.920842,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4219 10.3564C18.1914 10.3564 18.814 9.7324 18.814 8.96435C18.814 8.1963 18.1899 7.57227 17.4219 7.57227",
    stroke: "#9B59B6",
    strokeWidth: 0.920842,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.97725 5.23099C6.97725 5.23099 5.6768 4.19092 4.93494 5.67611C4.4173 7.21144 6.62364 8.31957 9.57668 7.57004C12.0641 6.93873 16.6331 5.08116 16.6331 5.08116",
    stroke: "#9B59B6",
    strokeWidth: 0.920842,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3221 10.445C6.6812 10.445 6.97232 10.1539 6.97232 9.79475C6.97232 9.43565 6.6812 9.14453 6.3221 9.14453C5.96299 9.14453 5.67188 9.43565 5.67188 9.79475C5.67188 10.1539 5.96299 10.445 6.3221 10.445Z",
    fill: "#9B59B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7596 10.445C14.1187 10.445 14.4098 10.1539 14.4098 9.79475C14.4098 9.43565 14.1187 9.14453 13.7596 9.14453C13.4005 9.14453 13.1094 9.43565 13.1094 9.79475C13.1094 10.1539 13.4005 10.445 13.7596 10.445Z",
    fill: "#9B59B6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_748_15124"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 26,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSidebarLogo);
export default __webpack_public_path__ + "static/media/close-sidebar-logo.034e59e4b6815c10ba2c712418a12256.svg";
export { ForwardRef as ReactComponent };